import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 22 19", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 19H22L11 0L0 19ZM12 16H10V14H12V16ZM12 12H10V8H12V12Z" }));
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
